import { PageType } from "@product/scmp-sdk";

import type { AppBarVariant } from "~/components/app-bar/helpers";
import type { Application } from "~/components/app-initializer/helpers";
import type { Variant as SectionVariant } from "~/pages/section/enums";

export const pathname = "/section";

export const page = {
  route(
    query: QueryParameters<{
      appBarVariant?: AppBarVariant;
      application?: Application;
      entityId: string;
      name?: string;
      parentSection?: string;
      relatedSectionsQueueName?: string;
      sectionVariant?: SectionVariant;
    }>,
  ) {
    return {
      pathname,
      query: { ...query, pageType: PageType.Section },
    };
  },
};
